import script from "./AppResizableDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppResizableDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./AppResizableDropdown.vue?vue&type=style&index=0&id=2695fa0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2695fa0c"]])

export default __exports__